<template>
  <div class="battery-section">
    <h4 style="margin-top: 20px;">{{ title }} <span style="font-size: 12px;
font-weight: 600;
background: #22c4901a;
padding: 1px;
border-radius: 4px;">{{link}}</span></h4>
    
    <table class="modern-table list js-order-list batch-tbl">
      <thead>
        <tr>
          <th>Фото</th>
          <th>Наименование</th>
          <th>Пуск. ток</th>
          <th>Емкость</th>
          <th>Наличие у нас</th>
          <th>Продано на эту машину за последний год</th>
          <th>Менеджеры которые продавали</th>
          <th>Цена (руб.)</th>
          <th>Бонус</th>
          <th>Количество</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="battery in batteries"
          :key="battery.id || battery.name"
        >
          <td style="max-width: 50px;">
            <img :src="battery.image" alt="Фото товара" style="max-width: 50px;" />
          </td>
          <td style="position: relative;">
            <a :href="battery.url" target="_blank">{{ battery.name }}</a>
            
            <div> {{ battery.article }}</div>

             <div class="property">
                  <span v-if="battery.korpus">Тип корпуса: {{ battery.korpus }}; </span>
                  <span v-if="battery.length">Габариты: {{ battery.length || battery.width || battery.height ? 
              `${battery.length ? battery.length : ''}*${battery.width ? battery.width : ''}*${battery.height ? battery.height : ''}` 
              : '' }}; </span>
              <span v-if="battery.polarka">Полярность: {{ battery.polarka }}; </span> 
              <div class="count">{{ battery.stockTotal }} <span v-if="battery.reserve">({{ battery.reserve }})</span> шт</div>
              </div>


            <span v-if="isProductInOrder && isProductInOrder(battery.id)" class="in-order-label">В заказе</span>
          </td>
          <td>{{ battery.startingCurrent || '' }}</td>
          <td>{{ battery.capacity || '' }}</td>
          <!--<td style="min-width: 85px; text-align: right;">
            <p v-for="loc in battery.stores" :key="loc.name">{{ loc.name }}</p>
          </td>
          <td>
            <p v-for="loc in battery.stores" :key="loc.name + '_val'">{{ loc.stock }}</p>
          </td>-->
          <td>
            
          <div style="display:flex;flex-wrap: wrap;">
            <p
              v-for="loc in battery.stores"
              :key="loc.name" class="tooltips_blue" 
            >
              <Tooltip v-if="loc.name === 'В пути'" :productId="battery.id">
                <i class="icon-truck"></i>
                {{ loc.name }}
              </Tooltip>
        <span
          v-else
          :class="[
            { 'blue-text': isBlueId(loc.name) },
            { 'green-karvata': isKarvata(loc.name) },
            'tooltip-wrapper'
          ]"
        >
          {{loc.name}}
          <span class="tooltip-content">
            {{ loc.stock }} шт.
            <span class="tooltip-arrow"></span>
          </span>
        </span>
            
              
            </p>
          </div>


          </td>
          <td><div>{{ battery._salesCount || 0 }} шт.</div></td>
          <td> <ul>
    <li
      v-for="(name, index) in getManagerNames(battery.managers)"
      :key="index"
    >
      {{ name }}
    </li>
  </ul></td>
          <td>{{ battery.price ? battery.price + ' руб.' : '' }}</td>
          <td>{{ battery.bonus || '' }}</td>
          <td>
            <button class="add-btn" @click="$emit('add-product', battery)">Добавить</button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'BatteryTable',
  props: {
    title: String,
    batteries: Array,
    link: String,
    managersDict: Array,
    isProductInOrder: Function 
  },
 
  methods: {
     isBlueId(id) {
      return ['Володько', 'Машинка', 'Салюты', 'Бельского'].includes(id);
    },

    isKarvata(id) {
        return ['Карвата'].includes(id);
    },
    getManagerNames(ids) {
      if (!Array.isArray(ids)) return [];
      return ids.map(id => {
        const found = this.managersDict.find(manager => manager.value === id);
        return found ? found.label : `ID: ${id}`;
      });
    }
  }
}
</script>


<style scoped>
button:not(:disabled), [type=button]:not(:disabled), [type=reset]:not(:disabled), [type=submit]:not(:disabled) {
    cursor: pointer;
    background-color: #fff;
    background-image: linear-gradient(180deg, #fff, #e9ecee);
    border: 1px solid #dee2e6;
    text-shadow: none;
}
.qty-btn {
  margin: 0 4px;
}
.in-order {
  background-color: #f0f8ff;
}
.in-order-label {
  color: #ff4500;
  font-weight: bold;
  margin-left: 4px;
}
.add-btn {
  background-color: #4CAF50;
  color: white;
  border: none;
  padding: 5px 10px;
  cursor: pointer;
  border-radius: 4px;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: sticky;
  top: 0;
  background-color: white;
  z-index: 10;
  padding: 10px;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1);
  flex-wrap: wrap;
}

.modal-overlay {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  
}


.modal-content {
    background: white;
    padding: 0px;
    border-radius: 5px;
    max-width: 80%;
    max-height: 80%;
    overflow-y: auto;
    position: relative;
    right: 0;
    left: 0;
    z-index: 1040;
    --default-padding: 56px 296px;
    max-width: 1192px;
    width: 100%;
    height: 100%;
    margin: 40px auto;
    border-radius: 0px;
    background: #fafafa;
    max-height: calc(100vh - 80px);
    overflow: hidden;
    margin: 60px auto 40px auto;
    overflow-y: scroll;
    position: relative;
}

.modal-content {
    background: #ffffff;
    width: 100%;
    max-width: 1340px;
    position: relative;
    overflow-y: auto;
    max-height: 95vh;
}


/* Фиксированный заголовок с поиском и кнопкой закрытия */
.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: sticky;
  top: 0;
  background-color: white;
  z-index: 10;
  padding: 10px;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1);
  flex-wrap: wrap;
}

.search-input_products {
  display: flex;
  gap: 10px;
  align-items: center;
}

.close-btn {
 
  background: none;
    background-color: rgba(0, 0, 0, 0);
    background-image: none;
  background-color: #fff;
  background-image: linear-gradient(180deg, #fff, #e9ecee);
  border: 1px solid #dee2e6;
  border-radius: 6px;
  cursor: pointer;
  display: inline-block;
  font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, Roboto, sans-serif;
  font-size: 14px;
  font-size: 0;
  font-weight: 400;
  height: 21px;
  line-height: 20px;
  line-height: 17px;
  overflow: hidden;
  padding: 8px;
  position: relative;
  text-decoration: none;
  text-overflow: ellipsis;
  text-shadow: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
  vertical-align: middle;
  white-space: nowrap;
  width: 21px;

}

table.modern-table {
  width: 100%;
  border-collapse: collapse;
}

/* Фиксированные заголовки столбцов таблицы */
table.modern-table thead tr th {
 
  background: #ffffff;
  z-index: 5;
}

table.modern-table th,
table.modern-table td {
  border: 1px solid #dee2e6;
  padding: 8px;
  text-align: left;
}


td span {
  background: #f4f6f8;
  padding: 3px 7px;
  font-size: 11px;
  border: solid 1px #19191921;
    border-top-color: rgba(25, 25, 25, 0.13);
    border-right-color: rgba(25, 25, 25, 0.13);
    border-bottom-color: rgba(25, 25, 25, 0.13);
    border-left-color: rgba(25, 25, 25, 0.13);
  border-radius: 8px;
}

.in-order-label {
  color: #ff4500;
     color: #ff4500;
    font-weight: bold;
    margin-left: 4px;
    background: transparent;
    border: 0px;
    padding: 0px;
    font-size: 12px;
}

.qty-btn, .add-btn {
  margin: 0 4px;
}

.load-more-btn {
  display: block;
  width: 100%;
  margin-top: 10px;
  padding: 10px;
  background-color: #fafafa;
  color: white;
  border: none;
  cursor: pointer;
  border-radius: 4px;
  color: black;
    font-weight: 500;
}

.qty-btn,
.add-btn {
  margin: 0 4px;
    padding: 8px 12px;
    font-size: 12px;
    font-weight: 500;
    border: none;
    cursor: pointer;
    color: #ffffff;
    border-radius: 5px;
    transition: background 0.3s ease;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

/* Стили для кнопок увеличения и уменьшения */
.qty-btn-decrease {
    color: #000000;
    cursor: pointer;
    background-color: #fff;
    background-image: linear-gradient(180deg, #fff, #e9ecee);
    border: 1px solid #dee2e6;
    text-shadow: none;
    box-shadow: none;
    font-weight: 600;
}

.bonus {
      background: #e4ffe4;
    margin-left: 6px;
    font-size: 10px;
    border: solid 1px #dee2e6;
    }

    .nobonus {
      background: #ff787838;
    margin-left: 6px;
    font-size: 10px;
    border: solid 1px #00000038;
    }

.qty-btn-increase {
  
    color: #000000;
    cursor: pointer;
    background-color: #fff;
    background-image: linear-gradient(180deg, #fff, #e9ecee);
    border: 1px solid #dee2e6;
    text-shadow: none;
    box-shadow: none;
}

.qty-btn:hover {
  opacity: 0.8;
}

.add-btn {
    background-color: #4CAF50!important;
    background-image: linear-gradient(180deg, #22c993, #20a77f)!important;
    color: #fff;
    width: 67%;
}

.load-more-btn {
  display: block;
  width: 100%;
  margin-top: 10px;
  padding: 10px;
  background-color: #fafafa;
  color: white;
  border: none;
  cursor: pointer;
  border-radius: 4px;
  color: black;
    font-weight: 500;
}

.load-more-btn:hover {
  background-color: #fafafa;
}

.button_quantity {
  display:flex;
  align-items:center;
  justify-content:center;
}

.input-field.clear-btn.empty {
  min-width: 250px;
  min-height: 35px;
}

.btn-close-modal:before {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24'%3E%3Cpath fill='%23FF5353' d='M7.113 6.176a.6.6 0 0 1 .848 0L12 10.214l4.038-4.038a.6.6 0 0 1 .849 0l.937.937a.6.6 0 0 1 0 .848L13.785 12l4.04 4.04a.6.6 0 0 1 0 .848l-.937.937a.6.6 0 0 1-.849 0L12 13.784l-4.038 4.04a.6.6 0 0 1-.849 0l-.937-.937a.6.6 0 0 1 0-.848l4.04-4.04-4.039-4.038a.6.6 0 0 1 0-.849l.937-.936Z'/%3E%3C/svg%3E");
    background-position: 50%;
    background-repeat: no-repeat;
    bottom: 0;
    content: "";
    height: 24px;
    left: 0;
    margin: auto;
    position: absolute;
    right: 0;
    top: 0;
    width: 24px;
}

.btn-close-modal {
  width: 35px;
    height: 35px;
    position: relative;
    border-radius: 6px;
}

.btn-close-modal:hover {
  opacity:.5;
}

.spinner {
  display: inline-block;
  width: 20px;
  height: 20px;
  border: 3px solid rgba(0, 123, 255, 0.3); /* полупрозрачная обводка */
  border-radius: 50%;
  border-top-color: #007bff; /* синяя обводка сверху */
  animation: spin 1s ease-in-out infinite;
  margin-right: 8px;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.load-more-btn {
  display: flex;
    align-items: center;
    justify-content: center;
}

.add-btn:hover {
  opacity:.5;
}


.modern-table tr:hover {
    background-color: #f9fafb;
    cursor: pointer;
}

.qty-btn:hover {
  opacity:.5;
}

td p{
    margin-bottom: 2px;
font-size: 12px;
line-height: 14px;
margin: 2px;
}



.quantity {
  background: transparent;
    border: 0px;
    font-size: 12px;
}

a {
    color: rgb(0 0 0);
    text-decoration: none;
    display: block;
}

.property {
    margin-top: 4px;
}

td .property span {
    background: transparent;
    padding: 0px;
    font-size: 10px;
    border: solid 0px #c7b0b0;
    margin: 0px;
}


.count {
    position: absolute;
    top: 5px;
    right: 5px;
    font-size: 10px;
    color: #6c757d;
}

.no-results {
  text-align: center;
  padding: 20px;
  font-size: 16px;
  color: #999;
}

.filter-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-left: 0px;

  margin-top: 20px;
  width: 100%;
}

.filter-tags label {
  font-size: 13px;
  background: linear-gradient(180deg, #fff, #e9ecee);
  padding: 6px 10px;
  border-radius: 4px;
  cursor: pointer;
  border: solid 1px #dee2e6;
}
.filter-tags input[type="checkbox"] {
  margin-right: 5px;
}


.tooltip-container {
  display: inline-flex;
  align-items: center;
}

.btntask {
  margin-right: 15px !important;
  background:  #f86d6d !important;
}

.blue-text {
  background: #baddba;
    color: #2a4f2afc;
    border-color: #2a4f2a4f;
  }

.tooltip-wrapper {
  position: relative;
  cursor: pointer;
  display: inline-block;
}

.green-karvata {
 color: #039be5;
    background: #e3f2fd;
    border-color: #76c7ee;
}

.tooltip-content {
  display: none;
  position: absolute;
  bottom: 125%; /* позиция над текстом */
  left: 50%;
  transform: translateX(-50%);
  background-color: #333;
  color: #fff;
  padding: 6px 10px;
  border-radius: 4px;
  font-size: 12px;
  white-space: nowrap;
  z-index: 10;
  opacity: 0;
  transition: opacity 0.2s;
}

.tooltip-wrapper:hover .tooltip-content {
  display: block;
  opacity: 1;
}

/* Стрелочка */
.tooltip-arrow {
  position: absolute;
  top: 100%; /* стрелка снизу тултипа */
  left: 50%;
  margin-left: -5px;
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 5px solid #333;
  background: transparent;
  padding: 0px;
}

ul {
  list-style: none;
}

</style>